<template>
  <main class="main main--dentists">
    <div class="gradient-bg"/>

    <component
      v-for="(component, index) in components"
      :key="index"

      :is="component"
    />

    <ui-footer/>
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiFooter from 'ui/Footer';

// Pages
import PagesDentistsHero from 'pages/infoDentists/Hero';
import PagesDentistsInstructions from 'pages/infoDentists/Instructions';
import PagesDentistsMission from 'pages/infoDentists/OurMission';
import PagesDentistSignup from 'pages/home/Dentists';

// Export
export default {
  name: `view-info-dentists`,

  // Meta data
  metaInfo: {
    title: meta.infoDentists.title,
    meta: createMeta(meta.infoDentists.meta),
  },

  // Components
  components: {
    UiFooter,
  },

  // Data
  data() {
    return {
      components: {
        PagesDentistsHero,
        PagesDentistsInstructions,
        PagesDentistsMission,
        PagesDentistSignup,
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// InfoDentists.vue?5e52beac